export default class UpdateAccountNumberState {
  loaded = false;

  update_account_number = {
    status: '',
  };
}
